module.exports = __webpack_public_path__ + "img/__icon_BUS_IZOTERMA.04caab0e.svg";